import { Route, Routes, Navigate } from "react-router-dom";
import { isEmpty } from "lodash";

import PublicLayout from "../../layouts/PublicLayout/PublicLayout";
import LogOutAuth from "../../components/Auth/LogOutAuth/LogOutAuth";
import LogInAuth from "../../components/Auth/LogInAuth/LogInAuth";
import AuthContext from "../../context/Auth/AuthContext";
import NotFoundPage from "../../components/Page/NotFoundPage/NotFoundPage";
import { decodeJWT, getCookies } from "../../utils";
import { convertRoleToPath } from "../../utils/enum";

const AuthContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);
  const decodedToken = decodeJWT(accessToken);

  const redirectUrl = `/${convertRoleToPath(decodedToken?.role)}`;

  return (
    <PublicLayout>
      <AuthContext>
        <Routes>
          {/* Log In */}
          <Route
            index
            path="/login"
            element={isLogin ? <Navigate to={redirectUrl} /> : <LogInAuth />}
          />
          {/* Log Out */}
          <Route path="/logout" element={<LogOutAuth />} />
          {/* Not Found */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthContext>
    </PublicLayout>
  );
};

export default AuthContainer;
